<template>
    <section class="section section-shaped section-lg my-0">
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-5">
                    <card type="secondary" shadow header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5"
                        class="border-0 card">
                        <template>
                            <div class="text-center text-muted mb-4">
                                <small>Silahkan masukan password baru Anda!</small>
                            </div>

                            <ValidationObserver v-slot="{ handleSubmit }">
                                <form ref="form" @submit.stop.prevent="handleSubmit(resetPassword)">
                                    <div class="mb-5">
                                        <div class="row">
                                            <div class="col-md-12 col-sm-12">
                                                <ValidationProvider name="Password Baru" rules="required"
                                                    v-slot="{ errors }">
                                                    <base-input type="password" placeholder="Password Baru"
                                                        addon-left-icon="ni ni-lock-circle-open" v-model="form.password"
                                                        :required="true" :error="errors[0]"
                                                        :valid="!errors[0]"></base-input>
                                                </ValidationProvider>
                                            </div>
                                            <div class="col-md-12 col-sm-12">
                                                <ValidationProvider name="Password Konfirmasi" rules="required"
                                                    v-slot="{ errors }">
                                                    <base-input type="password" placeholder="Password Konfirmasi"
                                                        addon-left-icon="ni ni-lock-circle-open"
                                                        v-model="form.password_confirmation" :required="true"
                                                        :error="errors[0]" :valid="!errors[0]"></base-input>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="row float-right">
                                            <div class="col-md-12 col-sm-12">
                                                <template v-if="isBusy">
                                                    <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                                                    <strong>Loading...</strong>
                                                </template>
                                                <base-button v-else type="success" nativeType="submit"
                                                    icon="ni ni-send">Reset Password</base-button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </ValidationObserver>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

import axios from "axios";
import Swal from "sweetalert2";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import qs from "qs";

export default {
    components: {
        PulseLoader,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            form: {
                token: null,
                password: null,
                password_confirmation: null,
            },
            isBusy: false,
        };
    },
    methods: {
        async resetPassword() {
            const me = this;
            try {
                this.isBusy = true;
                me.form.token = me.$route.params.token
                let { status } = await axios.post(
                    "/api/v1/reset-password-token",
                    qs.stringify(me.form)
                );

                if (status >= 200 && status <= 202) {
                    Swal.fire({
                        title: "",
                        text: "Reset Password Berhasil. Silahkan masuk ke Akun Anda",
                        icon: "success",
                        showCancelButton: false,
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "Tutup!",
                    }).then(() => {
                        me.$router.push("/home");
                    });
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.isBusy = false;
            }

        },
    }
};
</script>
<style lang="scss" scoped>

.card {
    border-color: #425d94 !important;
    margin-bottom: 20px;
    border: 1px solid !important;
}

</style>
